<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label v-show="label" class="control-label">
      {{ label }}
      <span v-if="$attrs.required || requiredMark" class="text-danger">*</span>
    </label>
    <div>
      <date-picker
          id="datepicker2"
          @input="$emit('input', $event)"
          @change="$emit('change', $event)"
          :range="range"
          :format="format"
          :clearable="clearable"
          :editable="editable"
          :value="value"
          :type="type"
          :popupClass="`${popupClass || ''}`"
          v-bind="$props"
          class="form-control"></date-picker>
    </div>
    <small class="text-danger" v-if="error">
      {{ error }}
    </small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>


<style>
.mx-input {
  border: none;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: none;
  height: auto;
  margin-top: -8px;
  padding: 0;
  padding-right: 40px;
  width: 100%;
}

.mx-datepicker {
  width: 100%;
}

.mx-datepicker-range {
  width: 100%;
}
</style>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {DatePicker},
  props: [
    'value',
    'error',
    'label',
    'help',
    'id',
    'type',
    'name',
    'requiredMark',
    'range',
    'format',
    'type',
    'clearable',
    'editable',
    'popupClass',
    'formatter',
    'value-type',
    'multiple',
    'inline'
  ],
  emits: ['update:modelValue']
};
</script>